﻿  import { mapGetters, mapState } from 'vuex';
  import errorMessage from './errorMessage.vue';

  export default {
name: 'ca-pbs-information',
props: ['viewmodel', 'editmode'],
components: {
    'ca-error-message': errorMessage
},
data: () => ({
    timerHandler: null
}),
    mounted: function() {
    this.$store.dispatch('setTexts', {
            'updatePaymentBillingConfiguration': this.viewmodel.updatePaymentBillingConfigurationErrorMessage
        });
    },
methods: {
        updatePBSInformation: function(e){
            const self = this;
            clearTimeout(self.timerHandler);
            self.timerHandler = setTimeout(function () {
                self.$store.dispatch('updatePBSInformation', { 'field': e.target.name, 'value': e.target.value });
                self.validatePBSInfo(e.target.name);
            }, 500);
        },
        validatePBSInfo: function(){
            const validatedPBSObject = this.isPBSInfoValid;
            this.$store.dispatch('setPBSInfoError',  validatedPBSObject);
        }
},
computed:
    Object.assign(
         mapState({
             orderId: state => state.creditaccount.order.orderId,
             customerWantsCreditAgreement: state => state.creditaccount.customerWantsCreditAgreement,
             pbsInformation: state => state.creditaccount.pbsInformation,
             paymentMethod: state => state.creditaccount.paymentMethod,
             creditEvaluation: state => state.creditaccount.creditEvaluation,
             errors: state => state.creditaccount.errors,
            warnings: state => state.creditaccount.warnings
         }),
          mapGetters({
              creditPaymentSelected: 'creditPaymentSelected', 
              collectPBSinfo: 'collectPBSinfo',
              isPBSInfoValid: 'isPBSInfoValid'
          })
    )
}